// import { useEffect } from 'react';
// import { NAVIGATION_ROUTES } from '../../src/config/NavigationRoutes';
// import withLoadingModal from '../../src/hocs/LoadingModal';
// import { useRouter } from 'next/router';

// const Signup = ({ toggleLoadingModal, modalIsOpen, setLoadingText }) => {
//     const router = useRouter();
//     useEffect(() => {
//         if (!modalIsOpen) {
//             setLoadingText('Redirecting...');
//             toggleLoadingModal();
//         }
//         if (window) router.replace(NAVIGATION_ROUTES.ROOT.route);
//     });

//     return <div />;
// };

// export default withLoadingModal(Signup);

import User from '../../src/layouts/Users';
import withAuth from '../../src/hocs/withAuth/withAuth';

export default withAuth(User);
